import analytics from '@utils/analytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DwMarker from '@common/components/common/DwMarker';
import ProductImage from '@moncler/components/product/ProductImage';
const ProductTileFeatured = (props) => {
    if (!props.product) {
        return React.createElement(React.Fragment, null);
    }
    const { t } = useTranslation();
    const product = typeof props.product === 'string' ? JSON.parse(props.product) : props.product;
    const imgEditorial = typeof props.imgEditorial === 'string' ? { path: props.imgEditorial } : props.imgEditorial;
    return (React.createElement(React.Fragment, null, product && (React.createElement("div", { className: "product-tile product-tile-featured", "data-product": product.id, tabIndex: -1 },
        React.createElement(DwMarker, { type: "product", uuid: product.uuid }),
        React.createElement("div", { className: "product-tile__card" },
            React.createElement("a", { href: product.productUrl, className: "product-tile__link", onClick: () => {
                    analytics.productClickTP(product, props.index, props.actionList);
                } },
                React.createElement("div", { className: "product-tile__image-wrapper" }, imgEditorial ? (React.createElement("img", { className: "product-tile__editorial-img", src: imgEditorial.path, alt: "" })) : (React.createElement(ProductImage, { productId: product.id, img: product.imgs, type: 'F', className: "product-tile__image", alt: "" }))),
                React.createElement("div", { className: "product-tile__info" },
                    !props.simplified && React.createElement("h3", { className: "product-tile__pd-name primary-s uppercase" }, product.productName),
                    !props.videoBg && (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "product-tile__description primary-s" }, props.description),
                        React.createElement("p", { className: "product-tile__cta uppercase primary-xs" }, t('button.shopnow')))))))))));
};
export default ProductTileFeatured;
